import { BaseModel } from '@fry/lib/store';

export class Venue extends BaseModel {

  init() {
    this.doc = this._getDoc();
  }

  private _getDoc() {
    const doc = Object.assign({}, this.orig);
    delete doc['_tmp_cache'];
    delete doc['dates'];
    return doc;
  }

  public get name() {
    return this.orig['name'];
  }

  public get description() {
    return this.orig['description'];
  }

  public get transformed() {
    return {...this.doc};
  }

  public applyDoc() {
    Object.assign(this.orig, this.doc);
  }

  public setValue(value) {
    this.orig = {...this.orig, ...value};
    this.init();
  }

}
